import { Box, Chip, Stack, Typography } from '@mui/material';

import { Container, Wrapper } from 'src/widgets/FeedFilter/SidebarShell';
import AIMonitoringBlock from 'src/widgets/FeedFilter/AIMonitoringBlock';

import { getQuestionnaireProgressState } from './Content';

import type { QuestionnaireProgressState } from './Content';

interface QuestionnaireProgressSidebarProps {
    progress?: QuestionnaireProgressState;
    isAwarded?: boolean;
    rewardPoints?: number;
}

export default function QuestionnaireProgressSidebar({
    progress = getQuestionnaireProgressState(),
    isAwarded = false,
    rewardPoints = 500,
}: QuestionnaireProgressSidebarProps) {
    const rewardStatus = isAwarded
        ? 'Начислено'
        : progress.isComplete
        ? 'Начислим после сохранения'
        : 'Заполните анкету';

    return (
        <Wrapper
            elevation={0}
            square={true}
        >
            <Container
                elevation={0}
                isDisabled={false}
            >
                <Stack gap={2.25}>
                    <AIMonitoringBlock />

                    <Box
                        sx={{
                            borderRadius: '14px',
                            border: '1px solid var(--lm-border)',
                            bgcolor: 'var(--lm-surface)',
                            p: 1.5,
                        }}
                    >
                        <Box
                            display="flex"
                            alignItems="center"
                            justifyContent="space-between"
                            gap={2}
                            mb={1.5}
                        >
                            <Typography sx={{ color: 'var(--lm-text)', fontWeight: 800 }}>Анкета</Typography>
                            <Chip
                                size="small"
                                label={`${progress.percent}%`}
                                sx={{ fontWeight: 700, bgcolor: 'var(--lm-accent-soft)', color: '#0044FF' }}
                            />
                        </Box>
                        <Box
                            sx={{
                                height: 8,
                                bgcolor: 'var(--lm-border)',
                                borderRadius: 999,
                                overflow: 'hidden',
                            }}
                        >
                            <Box
                                sx={{
                                    width: `${progress.percent}%`,
                                    height: '100%',
                                    bgcolor: '#0044FF',
                                    borderRadius: 999,
                                    transition: 'width 180ms ease',
                                }}
                            />
                        </Box>
                    </Box>

                    <Box
                        sx={{
                            p: 1.75,
                            borderRadius: 2,
                            backgroundColor: 'var(--lm-surface)',
                            border: '1px solid #DCE5EF',
                            boxShadow: '0 8px 18px rgba(17, 24, 39, 0.05)',
                        }}
                    >
                        <Stack
                            direction="row"
                            gap={1.5}
                            alignItems="center"
                        >
                            <Box
                                aria-hidden
                                component="span"
                                sx={{
                                    width: 46,
                                    height: 46,
                                    borderRadius: '14px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    background:
                                        'linear-gradient(135deg, rgba(255, 196, 87, 0.32) 0%, rgba(0, 68, 255, 0.08) 100%)',
                                    boxShadow: 'inset 0 0 0 1px rgba(255, 196, 87, 0.18)',
                                    fontSize: 25,
                                    lineHeight: 1,
                                    flexShrink: 0,
                                }}
                            >
                                🎁
                            </Box>
                            <Stack
                                gap={0.35}
                                minWidth={0}
                            >
                                <Typography
                                    variant="h3"
                                    sx={{
                                        color: '#0044FF',
                                        fontSize: 18,
                                        lineHeight: 1.1,
                                        fontWeight: 900,
                                    }}
                                >
                                    +{rewardPoints} баллов
                                </Typography>
                                <Typography
                                    variant="body2"
                                    sx={{
                                        color: isAwarded ? 'var(--lm-success-ink)' : '#475467',
                                        fontWeight: isAwarded ? 700 : 500,
                                    }}
                                >
                                    {rewardStatus}
                                </Typography>
                            </Stack>
                        </Stack>
                    </Box>
                </Stack>
            </Container>
        </Wrapper>
    );
}
